// extracted by mini-css-extract-plugin
export var cardHeader = "_hp-1";
export var contentCard = "_hp-0";
export var headerActions = "_hp-3";
export var reorderHandle = "_hp-5";
export var titleArea = "_hp-2";
export var titleAreaWithHandle = "_hp-4";